import LetterAvatar from "@/components/Avatar/LetterAvatar"
import { ColumnDef } from "@tanstack/react-table"

export type Customer = {
  id: number
  name: string
  email: string
  phone: string
  address: string
  created_by: number
  updated_by: number
  created_at: string
  updated_at: string
  // createdBy: User,
  // updatedBy: User
}

export type User = {
  id: number
  name: string
  email: string
}

export const columns: ColumnDef<Customer>[] = [
  {
    header: "User",
    cell: ({ row }) => <LetterAvatar name={row.original.name} />,
  },
  {
    header: "Email",
    accessorKey: "email",
  },
  {
    header: "Phone",
    accessorKey: "phone",
  },
  {
    header: "Address",
    accessorKey: "address",
  },
]
